import {RichTextTemplateTokens} from '../types';
import {splitTemplateTokenText} from './splitTemplateTokenText';
import {TEMPLATE_TOKEN} from './TEMPLATE_TOKEN';

/**
 * Marks the known placeholders of canonical HTML as token elements, with the label as text
 * content. The editor parses the result back through its token matcher, so a changed label
 * catalogue reloads as different HTML while the canonical value stays the same.
 */
export function renderTemplateTokens(html: string, getLabel: RichTextTemplateTokens['getLabel']) {
  const document = new DOMParser().parseFromString(html, 'text/html');
  const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
  const textNodes: Text[] = [];

  for (let node = walker.nextNode(); node; node = walker.nextNode()) {
    if (node instanceof Text) {
      textNodes.push(node);
    }
  }

  let hasToken = false;

  textNodes.forEach((textNode) => {
    const parts = splitTemplateTokenText(textNode.data, getLabel);

    if (!parts.some((part) => part.type === 'token')) {
      return;
    }

    hasToken = true;
    textNode.replaceWith(
      ...parts.map((part) => {
        if (part.type === 'text') {
          return document.createTextNode(part.text);
        }
        const element = document.createElement('span');
        element.className = TEMPLATE_TOKEN.className;
        element.dataset.code = part.code;
        element.textContent = part.label;

        return element;
      })
    );
  });

  return hasToken ? document.body.innerHTML : html;
}
